import { doGetQCXRequest, doPostQCXRequest } from '../../utils/api/domain/domain-api-utils';
import { CONTA_CORRENTE_PROCESSO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';


export async function fetchContaCorrenteByFollowUpId(followUpId) {
  return doGetQCXRequest(['movimentacao', CONTA_CORRENTE_PROCESSO_ENDPOINT, followUpId]);
}

export async function bloquearProcessoByFollowUpId(data) {
  return doPostQCXRequest(['movimentacao', CONTA_CORRENTE_PROCESSO_ENDPOINT, data.followUpId, 'bloquear'], [], [{name: 'bloqueado', value: data.bloqueado}]);
}